:host {
  --uui-breadcrumb-sep: "/";
  --uui-breadcrumb-font: var(--uui-primary-font-family);
  --uui-breadcrumb-color: var(--uui-theme-on-background);
  --uui-breadcrumb-link-active: var(--uui-theme-core-600);
  --uui-breadcrumb-link: var(--uui-theme-secondary-600);
  --uui-breadcrumb-link-hover: var(--uui-theme-secondary-500);
  --uui-breadcrumb-text-transform: inherit;
  --uui-breadcrumb-link-decoration: underline;

  font-family: var(--uui-breadcrumb-font);
  font-weight: var(--uui-font-weight-normal);
  font-size: var(--uui-small-font-size);
  line-height: var(--uui-small-line-height);
  margin-bottom: var(--uui-medium-bottom-margin);
  color: var(--uui-breadcrumb-link);
}

a {
  color: var(--uui-breadcrumb-link);
  text-transform: var(--uui-breadcrumb-text-transform);
  text-decoration: var(--uui-breadcrumb-link-decoration);
}

a:hover {
  color: var(--uui-breadcrumb-link-hover);
}

a:visited,
a:active {
  color: var(--uui-breadcrumb-link-active);
}

:host {
  font-family: var(--uui-breadcrumb-font);
  color: var(--uui-breadcrumb-color);
}

.separator {
  padding: 0.5em;
}

.separator::after {
  content: var(--uui-breadcrumb-sep);
}
